import type { IPermissionGroup } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const PERMISSION_GROUP_QUERY_KEY = "usePermissionGroupQuery";

interface Options {
  initialData?: IPermissionGroup;
  /** Set to true while the drawer is open so background refetches don't clobber local edits. */
  freeze?: boolean;
}

export const usePermissionGroupQuery = (
  id: string | null,
  options: Options = {}
) => {
  const { apiClient } = useTacticHooks();
  return useQuery<IPermissionGroup | null>({
    queryKey: [PERMISSION_GROUP_QUERY_KEY, apiClient.slug, id],
    queryFn: async () => {
      if (!id) return null;
      const res = await apiClient.permissionGroups.get(id);
      return res.result ?? null;
    },
    enabled: !!apiClient.slug && !!id,
    initialData: options.initialData,
    staleTime: options.freeze ? Infinity : 0,
    refetchOnMount: !options.freeze,
    refetchOnWindowFocus: !options.freeze
  });
};
